/**
 * DEPRECATED: Use useMyActor from '@/hooks/useMyActor' instead.
 *
 * This file is a backward-compat wrapper. Existing consumers will continue
 * to work but new code should import useMyActor directly.
 */

import { useMyActor } from './useMyActor';

interface DevActorInfo {
  actorId: string | null;
  actorName: string;
  loading: boolean;
}

/** @deprecated Use useMyActor() instead */
export function useDevActorId(): DevActorInfo {
  const { actorId, actorName, loading } = useMyActor();
  return { actorId, actorName, loading };
}
